import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useRecruiterStore } from '@/stores/recruiterStore';
import { toast } from '@/stores/toastStore';
import Card from '@/components/common/Card';
import Button from '@/components/common/Button';

export default function PaymentSuccessPage() {
  const { t } = useTranslation('recruiter');
  const { refreshProfile } = useRecruiterStore();
  const [searchParams] = useSearchParams();
  const subscriptionId = searchParams.get('subscription_id');

  useEffect(() => {
    toast.success(t('payment.success.toast'));
    refreshProfile();
  }, [refreshProfile, t]);

  return (
    <div className="container-custom py-12">
      <div className="max-w-2xl mx-auto">
        <Card className="text-center">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-green-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-3">{t('payment.success.title')}</h1>
          <p className="text-gray-600 mb-8">
            {t('payment.success.message')}
          </p>

          {subscriptionId && (
            <div className="mb-8 p-4 bg-gray-50 rounded-lg text-sm text-gray-500">
              <p>{t('payment.success.transactionComplete')}</p>
              <p className="font-mono mt-2 break-all">{t('payment.success.subscriptionId')} {subscriptionId}</p>
            </div>
          )}

          <Link to="/recruiter/dashboard">
            <Button variant="primary" className="flex items-center gap-2 mx-auto">
              {t('payment.success.goToDashboard')}
              <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
        </Card>
      </div>
    </div>
  );
}
